import { render, staticRenderFns } from "./BridgeInfoPanel.vue?vue&type=template&id=284d458e&scoped=true"
import script from "./BridgeInfoPanel.vue?vue&type=script&lang=js"
export * from "./BridgeInfoPanel.vue?vue&type=script&lang=js"
import style0 from "./BridgeInfoPanel.vue?vue&type=style&index=0&id=284d458e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284d458e",
  null
  
)

export default component.exports